"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BridgeModule = void 0;
const CarbonSDK_1 = require("../CarbonSDK");
const codec_1 = require("../codec");
const long_1 = __importDefault(require("long"));
const util_1 = require("../util");
const base_1 = __importDefault(require("./base"));
class BridgeModule extends base_1.default {
    getRelayFees(relayDenom, connectionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = this.sdkProvider.getTokenClient().configProvider.getConfig();
            const url = `${config.hydrogenUrl}/bridge_fees?fee_denom=${relayDenom}&connection_id=${connectionId}`;
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const result = yield util_1.FetchUtils.fetch(url, requestOptions).then((res) => res.json());
            return result;
        });
    }
    withdraw(params, opts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { connectionId, receiver, tokenDenom, tokenAmount, relayDenom, relayAmount, expirySeconds, } = params;
            const wallet = this.getWallet();
            const walletAddress = (_a = wallet.bech32Address) !== null && _a !== void 0 ? _a : '';
            const expiryDuration = codec_1.Duration.fromPartial({
                seconds: new long_1.default(expirySeconds),
            });
            const tokens = {
                denom: tokenDenom,
                amount: tokenAmount.toString(10),
            };
            const relayFee = {
                denom: relayDenom,
                amount: relayAmount.toString(10),
            };
            const value = CarbonSDK_1.Carbon.Bridge.MsgWithdrawToken.fromPartial({
                creator: walletAddress,
                connectionId,
                receiver,
                tokens: tokens,
                relayFee: relayFee,
                expiryDuration,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgWithdrawToken,
                value,
            }, opts);
        });
    }
    // withdrawing + unwrapping to the native token (wETH => ETH)
    withdrawAndExecute(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const { connectionId, executionContract, executionBytes, tokenDenom, tokenAmount, relayDenom, relayAmount, expirySeconds, } = params;
            const method = 'withdraw_native';
            const wallet = this.getWallet();
            const walletAddress = wallet.bech32Address;
            const expiryDuration = codec_1.Duration.fromPartial({
                seconds: new long_1.default(expirySeconds),
            });
            const value = CarbonSDK_1.Carbon.Bridge.MsgExecuteFromCarbon.fromPartial({
                creator: walletAddress,
                connectionId,
                executionContract,
                method,
                executionBytes,
                tokens: {
                    denom: tokenDenom,
                    amount: tokenAmount.toString(10),
                },
                relayFee: {
                    denom: relayDenom,
                    amount: relayAmount.toString(10),
                },
                expiryDuration,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgExecuteFromCarbon,
                value,
            }, opts);
        });
    }
}
exports.BridgeModule = BridgeModule;
